import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GraphqlService } from 'src/app/graphql/graphql.service';
import { FeatureFlagDefault } from '../../models/feature-flag-default';
import { AbstractPageForm } from '../../pages/page-form.abstract';

@Component({
	selector: 'pk-broker-feature-flag',
	standalone: false,
	templateUrl: './feature-flag.component.html',
	styleUrl: './feature-flag.component.scss',
})
export class FeatureFlagComponent extends AbstractPageForm {
	@Input() featureFlagDefault: FeatureFlagDefault;
	@Input() defaultValue: boolean;

	@Output() updated: EventEmitter<boolean> = new EventEmitter();

	constructor(
		private fb: FormBuilder,
		private graphqlService: GraphqlService,
	) {
		super();
	}

	public async loadPageData() {}

	public getForm() {
		return this.fb.group({
			value: [this.defaultValue, [Validators.required]],
		});
	}

	public async onFormLoaded() {
		this.form.value.valueChanges.subscribe(value => {
			this.updated.emit(value);
			this.updateFeatureFlagDefault(value);
		});
	}

	private async updateFeatureFlagDefault(value: boolean) {
		await this.graphqlService.updateUserFeatureFlag(this.featureFlagDefault.userFeatureFlagId, { value });
	}
}
